/* global google */
// do not delete above line. Needed for google address to function

import { basicAccountInfo } from "api/basic_account_info";
import { generic_get_api, generic_put_api } from "api/generic_api";
import { Component } from "react";
import { Button, Form } from 'react-bootstrap';
import { CODE_PARTS } from 'utils/constants';
import { EventNames, trackEvent } from 'utils/mixpanel';
import { JbkPlanningAdminFileType } from 'utils/jbk_planning_constants';


class CodeParts extends Component {

    constructor(props) {
        super(props);

        this.state = {
            parts: [],
            session_ok: false,
            working: false,
            file_name: '',
        };
        this.setPartValues = this.setPartValues.bind(this);
        this.fetchCodeParts = this.fetchCodeParts.bind(this);
        this.saveFiles = this.saveFiles.bind(this);
        this.resetEverythingAndFetch = this.resetEverythingAndFetch.bind(this);
    }

    resetEverythingAndFetch() {
        this.setState({ parts: [] }, this.fetchCodeParts);
    }

    fetchCodeParts() {
        this.setState({working: true });

        generic_get_api(CODE_PARTS, {file_name: this.state.file_name})
        .then(
            data => { 
                this.setState({
                    parts: data.parts,
                    working: false,
                })
            }
        )
        .catch(error => {
        });
    }

    saveFiles() {
        this.setState({working: true });
        generic_put_api(CODE_PARTS, 
            {   
                parts: this.state.parts,
            })
            .then(
                (result) => {
                    if(result.status === 204) {
                        this.setState(
                            {
                                working: false,
                                parts: [],
                            });
                    }
                }
            ).catch(error => {
            });
    }

    setPartValues(index, type, value) {
        let cur_parts = this.state.parts;
        let temp_part = cur_parts[index];

        temp_part[type] = value;
        this.setState({parts: cur_parts});
    }


    componentDidMount() {
        trackEvent(EventNames.PAGE_LOAD, {'data_1': 'code_parts'});
        basicAccountInfo()
        .then(
            data => {
                this.setState({session_ok: true});
            }
        ).catch(error => {
            if (error?.name === 'LOGIN_ERROR') {
                this.props.history.push('/login');
            }
        });

    }

    render() {
        const {parts, working, file_name} = this.state;

        return(
            <div class="container-fluid sfPlanningAdmin">
                {this.state.session_ok && 
                    <div class="row">
                        <div class="col-auto me-3">
                            <input type="text" class="form-control" value={file_name} placeholder="file_name" onChange={(e) => this.setState({file_name: e.target.value})}/> 
                            <Button variant="secondary" onClick={this.resetEverythingAndFetch}>OK</Button>
                        </div>
                    </div>
                }
                {
                    parts && parts.length > 0 &&
                    <div class="row mt-4 mb-4"><div class="col"><Button onClick={this.saveFiles}>Save</Button></div></div>
                }
                {
                    working && 
                    <div class="container mt-5 text-center">
                        <span class="spinner-border" aria-hidden="true"></span>
                    </div>
                }

                {
                    <>
                        {/* <>
                        <div class="row mt-5">
                            <div class="col-8 fw-bold">Text</div>
                            <div class="col-4">
                                <div class="row">
                                    <div class="col-4">ID</div>
                                    <div class="col-4">Order</div>
                                    <div class="col-4">Hierarchy</div>
                                </div>
                            </div>
                        </div>

                        </> */}
                        <>
                            {parts.map((part, index) =>{
                                return  <div class="row mt-1">
                                            <div class="col-8">
                                                <textarea class="form-control" rows="4" value={part.text} placeholder="text" style={{'font-size': '13px' }}onChange={(e) => this.setPartValues(index, 'text', e.target.value)}/> 
                                            </div>
                                            <div class="col-4">
                                                <Form>
                                                    <div class="row mt-3">
                                                    <   div class="col-1 ps-1">
                                                            {part.section}
                                                        </div>
                                                        <div class="col-4 ps-1">
                                                            <input type="text" class="form-control" value={part.hierarchy} placeholder="hierarchy" onChange={(e) => this.setPartValues(index, 'hierarchy', e.target.value)}/> 
                                                        </div>
                                                        <div class="col-3 ps-1">
                                                            <input type="text" class="form-control" value={part.ID} placeholder="ID" onChange={(e) => this.setPartValues(index, 'ID', e.target.value)}/> 
                                                        </div>
                                                        <div class="col-4 ps-1">
                                                            <input type="text" class="form-control" value={part.order}  placeholder="order" onChange={(e) => this.setPartValues(index, 'order', Number(e.target.value))}/> 
                                                        </div>
                                                    </div>
                                                </Form>
                                            </div>
                                            <div><hr></hr></div>
                                        </div>
                            })}
                        </>
                    </>
                }
                {
                    parts && parts.length > 0 &&
                    <div class="row mt-4"><div class="col"><Button onClick={this.saveFiles}>Save</Button></div></div>
                }
            </div>
        )
    }
}

export default CodeParts;